export const lists_translations_credits = [
    {
        "nl_NL": {
            "lastupdate": "Laatste update",
            "pagedescription": "Op deze pagina vind je het gemiddelde aantal credits wat een melding in een versie opleverd.",
            "place": "Plek",
            "amountmissions": "Aantal inzetten",
            "averagemissions": "Gemiddelde",
            "planned": "Geplande inzetten",
            "plannedavg": "Gemiddelde geplande inzetten",
            "alliance": "Teaminzetten",
            "allianceavg": "Gemiddelde teaminzetten",
            "language": "Taal",
            "locale": "Versie",
            "loading": "Momenteel verzamelen we de data, een moment geduld A.U.B."
        },
        "en_EN": {
            "lastupdate": "Last update",
            "pagedescription": "On this page you will find the average number of credits that a missions pay out in a version.",
            "place": "Place",
            "amountmissions": "Amount missions",
            "averagemissions": "Average",
            "planned": "Planned missions",
            "plannedavg": "Average planned missions",
            "alliance": "Alliance missions",
            "allianceavg": "Average alliance missions",
            "language": "Language",
            "locale": "Version",
            "loading": "We are currently collecting data, please wait."
        },
        "de_DE": {
            "lastupdate": "Letztes Update",
            "pagedescription": "Auf dieser Seite finden Sie die durchschnittliche Anzahl an Credits, die eine Mission in einer Version auszahlt.",
            "place": "Rangplatz",
            "amountmissions": "Anzahl einsaetze",
            "averagemissions": "Durchschnitt",
            "planned": "Geplante einsaetze",
            "plannedavg": "Durchschnitt Geplante einsaetze",
            "alliance": "Verband einsaetze",
            "allianceavg": "Durchschnitt verband einsaetze",
            "language": "Sprache",
            "locale": "Version",
            "loading": "Wir sammeln gerade Daten, bitte warten."
        }
    }
]
